import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

const VERSION = `${process.env.REACT_APP_VERSION_API}`;

export const GetAllSetupsUsers = async ({
  limit = 10,
  page = 1,
  search,
  user_type,
  category_uuid,
  status = true,
  committeeType,
  use_for = "dropdown",
  other_than,
  with_than,
  company_uuid,
  all_users,
  has_access, // has_access = 1 => get users with access to the company
  is_same_branch, // is_same_branch = 1  => get users with same branch
  all_employee,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (user_type || user_type === 0) queryList.push(`user_type=${user_type}`);
  if (category_uuid) queryList.push(`category_uuid=${category_uuid}`);
  if (status && use_for !== "dropdown") queryList.push(`status=${status}`);
  if (committeeType) queryList.push(`user_for=${committeeType}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (all_users) queryList.push(`all_users=${all_users}`);
  if (has_access) queryList.push(`has_access=${has_access}`);
  if (is_same_branch) queryList.push(`is_same_branch=${is_same_branch}`);
  if (typeof all_employee === "number") queryList.push(`all_employee=${all_employee}`);
  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${VERSION}/user?${queryList.join("&")}`,
    {
      params: {
        with_than,
        other_than,
      },
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const getSetupsUsersById = async ({uuid}) => {
  const queryList = [];
  if (uuid) queryList.push(`uuid=${uuid}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${VERSION}/user/view?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
